<script>
  import { createEventDispatcher } from 'svelte';
  import CaptureService from '../services/capture.service';
  export let selectedProperties = [];

  const dispatch = createEventDispatcher();

  const list=CaptureService.getProperties();
  const rootProperties = list.reduce((previous, current) => {
    if(current.rootCapture === true){
      if(previous.findIndex(p => p.name === current.name)== -1){
        previous.push({ name: current.name, id: current.id });
      }
    }
    return previous;
  }, []);

  console.log('rootProperties: ', rootProperties);
  const addTag = prop => {
    if(selectedProperties.findIndex(p => p.name === prop.name) === -1){
      selectedProperties = [...selectedProperties, prop];
      dispatch('change', selectedProperties);
    }
  };
  let showDropDown = false;
  const removeTag = index => {
    selectedProperties.splice(index, 1);
    selectedProperties = [...selectedProperties];
  }
</script>

<div class="container">
  <div class="tags">
    <ul class="tags-list">
      {#each selectedProperties as prop,index}
      <li>
        <div class="tag">
          <div class="tag-name">{prop.name}</div>
          <div class="tag-remove" on:click={()=>removeTag(index)}>x</div>
        </div>
      </li>
      {/each}
    </ul>
  </div>
  <button type="button" on:click|preventDefault|stopPropagation={()=>{showDropDown = !showDropDown}}>
    {#if showDropDown === false}
    Add
    {:else}
    Done
    {/if}
  </button>
</div>
{#if showDropDown}
<div class="drop-down">
  <ul class="drop-down-list">
    {#each rootProperties as property}
    <li on:click={()=>{addTag(property)}}>{property.name}</li>
    {/each}
  </ul>
</div>
{/if}

<style>
  .container {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
  
  ul {
    list-style: none;
    overflow: scroll;
  }

  .tags {
    flex: 1;
    background-color: white;
    border-radius: 5px;
    min-width: 0;
  }

  button {
    padding: 6px 30px;
    font-size: 1.2em;
    border-radius: 5px;
  }

  .tags-list {
    height: 100%;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    margin-left: 3px;
  }

  .tag {
    display: flex;
    flex-direction: row;
    height: 100%;
    border: 1px solid darkgray;
    border-radius: 3px;
    background-color: lightgray;
    padding: 5px 20px;
    position: relative;
  }

  .tag-remove {
    display: inline;
    position: absolute;
    font-size: 0.90em;
    width:1em;
    height:1em;
    top:-5px;
    right: -5px;
    background-color: lightgray;
    border: 1px solid darkgray;
    border-radius: 50%;
    text-align: center;
    color: darkgray;
  }

  .drop-down {
    position: relative;
  }

  .drop-down-list {
    position: absolute;
    right: 0px;
    display: flex;
    flex-direction: column;
    background-color: #D77C33;
    color: #FDFDFD;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #333;
    z-index: 10;
  }

  .drop-down-list li:hover {
    color: #333;
  }
</style>